let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
export const AvatarImage = styledWithTheme.div(_t || (_t = _`
  position: absolute;
  inset: 0;
  background-image: url(${0});
  background-size: cover;
  background-position: center;
`), ({
  $src
}) => $src);